// 專題頁面 專題列表
"use client";
import { useState } from "react";
import ProjectComponent from "@/components/basic/ProjectComponent"; // 專題元件
import LoadMore from "../index/LoadMore";
import { getProjectByPage } from "@/app/actions";

const ProjectList = ({ initialProjectList, pageCnt, locale }) => {
  const [projectList, setProjectList] = useState(initialProjectList); // 專題列表
  const [pageIndex, setPageIndex] = useState(1); // 頁碼
  const [loadingMore, setLoadingMore] = useState(false); // 載入更多

  // 取得更多專題
  const getMoreProject = async () => {
    try {
      setLoadingMore(true);
      const { data } = await getProjectByPage(locale, pageIndex);
      if (data) {
        setProjectList((prev) => prev.concat(data));
        setPageIndex((prev) => prev + 1);

        setTimeout(() => {
          setLoadingMore(false);
        }, 300);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    // 列表
    <>
      <section className="space-y-[40px]">
        {projectList?.map((project, i) => (
          <ProjectComponent
            key={project?.title + "project-list" + i}
            project={project}
          />
        ))}
      </section>

      {/* 載入更多 */}
      {pageCnt > pageIndex && (
        <LoadMore loadingMore={loadingMore} onLoad={getMoreProject} />
      )}
    </>
  );
};

export default ProjectList;
